var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterR(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5239,
    cy: 11.8821,
    r: 11.3821,
    fill: "#F3F6ED",
    stroke: "#A2BE71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.216 15.012C16.32 15.012 16.398 14.999 16.463 14.973V16C16.346 16.013 16.242 16.026 16.177 16.026C15.436 16.026 14.799 15.818 14.292 15.389C13.785 14.96 13.226 14.18 12.615 13.023L12.082 12.048H10.223V16H9.118V6.965H12.836C14.721 6.965 15.813 7.914 15.813 9.513C15.813 10.956 14.877 11.944 13.317 12.035L13.59 12.542C14.097 13.465 14.552 14.115 14.955 14.466C15.358 14.83 15.774 15.012 16.216 15.012ZM12.836 7.94H10.223V11.073H12.836C14.058 11.073 14.669 10.553 14.669 9.513C14.669 8.46 14.058 7.94 12.836 7.94Z",
    fill: "#8EB052"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterR);
export default __webpack_public_path__ + "static/media/letterR.ac1e5993f8b386de90bd77ec858d47f5.svg";
export { ForwardRef as ReactComponent };